export default class UserGroupRequest {
    constructor(
        public name: string = '',
        public key: string = '',
        public permissions: string[] = [] //IRIs
    ) {
    }
}
